import { effect, Service, signal } from '@angular/core';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'theme';

@Service()
export class ThemeService {
    // Initial value mirrors the class already applied by the pre-paint script in index.html.
    readonly theme = signal<Theme>(document.documentElement.classList.contains('dark') ? 'dark' : 'light');

    constructor() {
        effect(() => {
            const theme = this.theme();
            document.documentElement.classList.toggle('dark', theme === 'dark');
            localStorage.setItem(STORAGE_KEY, theme);
        });
    }

    toggle(): void {
        this.theme.update((theme) => (theme === 'dark' ? 'light' : 'dark'));
    }
}
